import { palettes } from '../theme/tokens/palettes';

/**
 * Avatar / profile gradient pairs — all sourced from Codex palette tokens.
 * Each entry is [fromColor, toColor] for a linear-gradient.
 */
const GRADIENTS: [string, string][] = [
  [palettes.tyrian[500], palettes.woad[400]], // purple → indigo
  [palettes.carmine[400], palettes.sienna[400]], // pink → orange
  [palettes.laurel[500], palettes.lapis[400]], // green → blue
  [palettes.saffron[500], palettes.cinnabar[400]], // amber → red
  [palettes.iris[500], palettes.carmine[400]], // violet → pink
];

export function getGradient(seed: number | string): string {
  const idx = (typeof seed === 'string' ? seed.charCodeAt(0) : seed) % GRADIENTS.length;
  const [a, b] = GRADIENTS[idx];
  return `linear-gradient(135deg, ${a}, ${b})`;
}

/** Returns a pseudo-random gradient. Alias for getGradient with a random seed. */
export function getRandomGradient(): string {
  return getGradient(Math.floor(Math.random() * GRADIENTS.length));
}
